import {
  Children,
  cloneElement,
  type PropsWithChildren,
  type ReactElement } from
'react';

import { type BookmakersConfig } from '@cx-modules/types';

import {
  GridTable,
  TableGroup } from
'~/components/OddscheckerPlus/components/cxy';
import { type BettingInsights } from '~/configuration/betting-insights/BettingInsightsConfig';
import {
  type BettingInsightsContent,
  type BettingSplitsIndex,
  type BettingSplitsResult,
  type EsIndex } from
'~/configuration/betting-insights/types';
import { type BettingInsightsUI } from '~/configuration/betting-insights/ui/BettingInsightsUI';
import type ODDS_FORMAT from '~/enums/odds_format';

import { EventDetails } from '../EventDetails';
import { type SectionProps } from '../ResultTable';

import styles from './styles/BettingSplits.module.css';

function BettingSplits({
  children,
  config,
  content,
  result




}: {config: BettingInsights<BettingSplitsIndex>;content: BettingInsightsContent<BettingSplitsIndex>[];result: BettingSplitsResult;} & PropsWithChildren) {
  return (
    <TableGroup
      label={
      <EventDetails<BettingSplitsIndex>
        content={content}
        renderTitle={config.ui.card.title.render}
        result={result} />

      }>

			<>
				{Children.map(children, (child, index) =>
        <GridTable
          className={styles.bettingSplits}
          key={`${result.subeventName}-${result.eventDisplayName}-${result.subeventStartTime}-pbd-table-${index}`}
          label={result.subeventName}
          mobileColumns={3}>

						{cloneElement(child as ReactElement)}
					</GridTable>
        )}
			</>
		</TableGroup>);

}

function BettingSplitsBody<
  TIndex extends EsIndex,
  TContent extends BettingInsightsContent<TIndex>>(
{
  bookmakers,
  cells,
  content,
  isFootball,
  oddsFormat,
  resultIndex,
  sectionProps








}: {bookmakers: BookmakersConfig;cells: BettingInsightsUI<TIndex>['card']['table']['cells'];content: TContent;isFootball?: boolean;oddsFormat: ODDS_FORMAT;resultIndex: number;sectionProps: SectionProps;} & PropsWithChildren) {
  const Comparison = () =>
  <GridTable.Cell
    isFullWidthMobile={cells[1].isFullWidthMobile}
    isMain={cells[1].isMain}
    justifyContent={cells[1].justifyContent}
    order={cells[1].order}>

			{cells[1].render({
      content,
      bookmakers,
      oddsFormat,
      resultIndex
    })}
		</GridTable.Cell>;


  const LeftBet = () =>
  <GridTable.Cell
    justifyContent={cells[0].justifyContent}
    start={cells[0].start}>

			{cells[0].render({
      content,
      bookmakers,
      oddsFormat,
      resultIndex
    })}
		</GridTable.Cell>;

  const CenterBet = () =>
  <GridTable.Cell
    justifyContent={cells[3].justifyContent}
    start={cells[3].start}>

			{cells[3].render({
      content,
      bookmakers,
      oddsFormat,
      resultIndex
    })}
		</GridTable.Cell>;

  const RightBet = () =>
  <GridTable.Cell
    justifyContent={cells[2].justifyContent}
    start={cells[2].start}>

			{cells[2].render({
      content,
      bookmakers,
      oddsFormat,
      resultIndex
    })}
		</GridTable.Cell>;


  return (
    <GridTable.Body {...sectionProps} role="rowgroup">
			{isFootball ?
      <>
					<GridTable.Row>
						<Comparison />
					</GridTable.Row>
					<GridTable.Row>
						<LeftBet />
						<CenterBet />
						<RightBet />
					</GridTable.Row>
				</> :

      <GridTable.Row>
					<LeftBet />
					<Comparison />
					<RightBet />
				</GridTable.Row>
      }
		</GridTable.Body>);

}

BettingSplits.Body = BettingSplitsBody;

export { BettingSplits };